import React, { ComponentPropsWithRef, VFC } from 'react'

import { TextField as UIComponentTextField } from '@style-port/roov-ui-components-react'
import { ErrorTxt } from 'src/components/atoms'

type InputProps = ComponentPropsWithRef<'input'>
type Props = InputProps & {
  interactive?: boolean
  sizeType?: 's' | 'm' | 'l'
  errorMessage?: string
  forwardRef?: React.Ref<HTMLInputElement> | React.ForwardedRef<HTMLInputElement>
}

const BaseTextField: VFC<Props> = ({ className, errorMessage, forwardRef, ...inputProps }) => {
  return (
    <div className={className}>
      <UIComponentTextField
        state={errorMessage ? 'error' : undefined}
        forwardRef={forwardRef}
        {...inputProps}
      />
      {errorMessage && <ErrorTxt text={errorMessage} showIcon className="tw-mt-s-4" />}
    </div>
  )
}

// refを使う上で forwardRef を使って上げる必要がある
// 参考: https://blog.gaji.jp/2021/01/08/6247/
export const TextField = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  return <BaseTextField {...props} forwardRef={ref} />
})
